import { useState } from "react";
import { ChevronLeft, ChevronRight, Plus } from "lucide-react";

const DAYS = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
const statusCls = {
  available: "bg-emerald-100 text-emerald-800 border-emerald-300",
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  booked: "bg-blue-100 text-blue-800 border-blue-300",
};

function startOfWeek(d) {
  const x = new Date(d); x.setHours(0, 0, 0, 0);
  const day = (x.getDay() + 6) % 7;
  x.setDate(x.getDate() - day);
  return x;
}
const pad = (n) => String(n).padStart(2, "0");
const toLocalInput = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export default function WeekCalendar({ slots, onCreate }) {
  const [weekStart, setWeekStart] = useState(startOfWeek(new Date()));
  const days = [...Array(7)].map((_, i) => { const d = new Date(weekStart); d.setDate(d.getDate() + i); return d; });
  const weekEnd = new Date(weekStart); weekEnd.setDate(weekEnd.getDate() + 7);
  const today = new Date().toDateString();
  const fmt = (d) => d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });

  const create = (d) => { const s = new Date(d); s.setHours(9, 0, 0, 0); onCreate(toLocalInput(s)); };

  return (
    <div className="mt-4 sc-card" data-testid="week-calendar">
      <div className="flex items-center justify-between">
        <button data-testid="calendar-prev" onClick={() => setWeekStart((w) => { const d = new Date(w); d.setDate(d.getDate() - 7); return d; })} className="p-2 rounded-full hover:bg-slate-100"><ChevronLeft className="w-4 h-4" /></button>
        <div className="font-semibold text-slate-900" data-testid="calendar-range">Semaine du {fmt(days[0])} au {fmt(days[6])}</div>
        <div className="flex gap-1">
          <button data-testid="calendar-today" onClick={() => setWeekStart(startOfWeek(new Date()))} className="text-xs px-2 py-1 rounded-full border border-slate-200 hover:bg-slate-100">Aujourd'hui</button>
          <button data-testid="calendar-next" onClick={() => setWeekStart((w) => { const d = new Date(w); d.setDate(d.getDate() + 7); return d; })} className="p-2 rounded-full hover:bg-slate-100"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-7 gap-1.5">
        {days.map((d, i) => {
          const daySlots = slots.filter((s) => { const t = new Date(s.start); return t.toDateString() === d.toDateString(); }).sort((a, b) => new Date(a.start) - new Date(b.start));
          const isToday = d.toDateString() === today;
          return (
            <div key={i} data-testid={`calendar-day-${i}`} className={`rounded-xl border p-1.5 min-h-[120px] flex flex-col ${isToday ? "border-emerald-500 bg-emerald-50/40" : "border-slate-200"}`}>
              <div className="text-[11px] font-semibold text-slate-600 text-center">{DAYS[i]} <span className={isToday ? "text-emerald-700" : ""}>{d.getDate()}</span></div>
              <div className="mt-1 space-y-1 flex-1">
                {daySlots.map((s) => (
                  <div key={s.id} title={s.room?.name} className={`text-[10px] px-1.5 py-1 rounded-md border truncate ${statusCls[s.status] || "bg-slate-100 text-slate-700 border-slate-200"}`}>
                    {new Date(s.start).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })} · {s.room?.name?.split(" ")[0]}
                  </div>
                ))}
              </div>
              <button data-testid={`calendar-add-${i}`} onClick={() => create(d)} className="mt-1 w-full text-[11px] text-slate-500 hover:text-emerald-700 hover:bg-emerald-50 rounded-md py-0.5 flex items-center justify-center gap-0.5"><Plus className="w-3 h-3" /> Créneau</button>
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex gap-3 text-[11px] text-slate-500">
        <span><span className="inline-block w-2 h-2 rounded-full bg-emerald-400 mr-1" />Libre</span>
        <span><span className="inline-block w-2 h-2 rounded-full bg-amber-400 mr-1" />En attente</span>
        <span><span className="inline-block w-2 h-2 rounded-full bg-blue-400 mr-1" />Réservé</span>
      </div>
    </div>
  );
}
